import { Navigate } from "react-router-dom";

/**
 * Legacy route shell — task applications UI lives under
 * Rewards → "Task applications" (`/rewards?tab=applications`).
 */
const TaskPage = () => (
  <Navigate to="/rewards?tab=applications" replace />
);

export default TaskPage;
